import React from 'react';
import {useAppContext} from 'contexts';
import {JobCBCTable} from 'shared/components/Table/JobCBCTable';
import {
    useBenchtopTableConfig,
    View,
} from 'components/customer/BTM/helper/useBenchtopTableConfigInDetailCart';

export const SidebarRightBenchtopModule = () => {
    const {tableConfig} = useBenchtopTableConfig(View.CART);
    const {userProfile} = useAppContext();

    if (userProfile.isBenchtopAvailable && tableConfig) {
        return (
            <JobCBCTable
                options={tableConfig}
                className="word-break-cbc-table table-head-inherit-bg"
            />
        );
    }
};
